export const colSpanFieldsFunction = (fieldColSpan, colContStart) => {
    if(fieldColSpan > colContStart){
        return colContStart
    }
    else{
        return fieldColSpan
    }
}